// frontend/src/api/agreement.api.js
import apiClient from "./client.js";

// ─── Agreements ───────────────────────────────────────────────────────────────

export const getAgreements = async (params = {}) => {
  const response = await apiClient.get("/agreements", { params });
  return response.data;
};

export const getAgreement = async (id) => {
  const response = await apiClient.get(`/agreements/${id}`);
  return response.data.data;
};

export const submitAgreement = async (data) => {
  const response = await apiClient.post("/agreements", data);
  return response.data.data;
};

export const updateAgreement = async (id, data) => {
  const response = await apiClient.put(`/agreements/${id}`, data);
  return response.data.data;
};

export const uploadAgreementFile = async (id, formData) => {
  const response = await apiClient.post(`/agreements/${id}/file`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.data;
};

export const getAgreementFileUrl = async (id) => {
  const response = await apiClient.get(`/agreements/${id}/file`);
  return response.data.data;
};

export const moveAgreementToReview = async (id) => {
  const response = await apiClient.post(`/agreements/${id}/move-review`);
  return response.data.data;
};

export const reviewAgreement = async (id, { action, comment }) => {
  const response = await apiClient.post(`/agreements/${id}/review`, {
    action,
    comment,
  });
  return response.data.data;
};

export const terminateAgreement = async (id, reason) => {
  const response = await apiClient.post(`/agreements/${id}/terminate`, {
    reason,
  });
  return response.data.data;
};

export const updatePaymentStatus = async (
  id,
  { paymentStatus, paymentDate },
) => {
  const response = await apiClient.patch(`/agreements/${id}/payment`, {
    paymentStatus,
    paymentDate,
  });
  return response.data.data;
};

// ─── Addendums ────────────────────────────────────────────────────────────────

export const getAddendums = async (agreementId) => {
  const response = await apiClient.get(`/agreements/${agreementId}/addendums`);
  return response.data.data;
};

export const submitAddendum = async (agreementId, data) => {
  const response = await apiClient.post(
    `/agreements/${agreementId}/addendums`,
    data,
  );
  return response.data.data;
};

export const updateAddendum = async (agreementId, addendumId, data) => {
  const response = await apiClient.put(
    `/agreements/${agreementId}/addendums/${addendumId}`,
    data,
  );
  return response.data.data;
};

export const uploadAddendumFile = async (agreementId, addendumId, formData) => {
  const response = await apiClient.post(
    `/agreements/${agreementId}/addendums/${addendumId}/file`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data.data;
};

export const reviewAddendum = async (
  agreementId,
  addendumId,
  { action, comment },
) => {
  const response = await apiClient.post(
    `/agreements/${agreementId}/addendums/${addendumId}/review`,
    { action, comment },
  );
  return response.data.data;
};

export const getAddendumFileUrl = async (agreementId, addendumId) => {
  const response = await apiClient.get(
    `/agreements/${agreementId}/addendums/${addendumId}/file`,
  );
  return response.data.data;
};

export const getAddendumPrevFileUrl = async (agreementId, addendumId) => {
  const response = await apiClient.get(
    `/agreements/${agreementId}/addendums/${addendumId}/prev-file`,
  );
  return response.data.data;
};
